import { Base } from './_base';

export class PostbackBackend extends Base {
  constructor(item) {
    super(item);
  }
}
